import React from "react";
import { ForgetPasswordStep3Styled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { Inputs, Buttons } from "components";

const ForgetPasswordStep3 = ({ onSubmit }) => {
  const { t } = useTranslation(["common"]);
  const schema = yup.object().shape({
    test: yup.string().required("New password is required"),
  });

  const {
    control,
    handleSubmit,
    // formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  return (
    <ForgetPasswordStep3Styled>
      <div className="register_header">
        {t("Reset your password", { ns: "common" })}
      </div>
      <div className="register_title">
        {t("Email provided", { ns: "common" })}
      </div>
      <div className="register_email">admin001@example.com</div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.Password
              theme_standard2
              className="new_password"
              label={t("Enter new password", { ns: "common" })}
              placeholder="********"
              {...field}
              // placeholder={t('test')}
              // errors={errors.phone?.message}
            />
          )}
          name="test"
          defaultValue=""
        />
        <Controller
          control={control}
          render={({ field }) => (
            <Inputs.Password
              theme_standard2
              className="confirm_new_password"
              label={t("Confirm password", { ns: "common" })}
              placeholder="********"
              {...field}
              // placeholder={t('test')}
              // errors={errors.phone?.message}
            />
          )}
          name="test"
          defaultValue=""
        />
      </form>
      <div className="register_button">
        <Buttons.BgStandard label={t("Save new password", { ns: "common" })} />
      </div>
      <div className="password_change_successfull">
        {/* <Cards.PasswordChangeSuccessfull/> */}
      </div>
    </ForgetPasswordStep3Styled>
  );
};

ForgetPasswordStep3.propTypes = {};

export default ForgetPasswordStep3;
